module.exports = __webpack_public_path__ + "assets/align-top-blue.6589b7d2.svg";